<div class="box-theme asistente-virtual">
  <div class="body">
    <img src="./assets/img/icono_asistente.png" alt="Contacta un asistente online" class="icono">
    <h1>
      Contacta a un asistente online
    </h1>
    <p>
      Contáctate de forma online con un ejecutivo comercial de
      Metrogas a través de una videollamada y resuelve todas tus
      dudas sobre tu boleta, saldos y otros productos y servicios
      relacionados a tu suministro de gas natural.
    </p>
    <h2>Santiago</h2>
    <h2>El Regidor 54, Las Condes</h2>
    <h2>(a pasos del Metro El Golf)</h2>
    <h2>Horario de atención</h2>
    <p class="subtitulo">
      Lunes a Viernes de 08:30 a 13:00 hrs<br/>
      Excepto festivos.

    </p>
    <p>
      Servicio compatible con Google Chrome y Safari.
    </p>
    <div class="footer">
      <div class="callToAcction">
        <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
      </div>
    </div>
  </div>
</div>

